import { useLocation } from "react-router-dom"
import { useVariation } from "@hackler/react-sdk"
import qs from "qs"

export default function useLogReferralKey() {
  const { search } = useLocation()
  const queryString = qs.parse(search, { ignoreQueryPrefix: true })
  const key = Number(queryString.key)
  if (!Number.isNaN(key)) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useVariation(Number(key))
  }
}
